import React, { Component } from 'react'
import './imd-students.scss'
import SchoolUserApi from '../../../apis/student'
import Loading from '../../common/loading/loading'
import FilterComponent from '../filter/filter'
import PaginationComponent from '../../common/cw-pagination/cw-pagination-v2'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowDown,
  faArrowUp,
  faCheckCircle,
  faTicketAlt,
  faTimesCircle
} from '@fortawesome/free-solid-svg-icons'
import { Constants } from '../../../constants/constants'

class IMDStudents extends Component {
  state = {
    imdStudents: [],
    meta: { totalPages: 1, page: 1 },
    isLoading: false,
    selectedPage: 1
  }
  limit = 10;
  currentPage = 1;
  startIndex = 1;
  filter = {}
  constructor (props) {
    super(props)
    this.gmcAllowed = this.props.gmcAllowed
  }

  componentDidMount () {
    const { selectedClass } = this.props
    const payload = {}
    if (selectedClass && selectedClass !== 'All') {
      payload.class = selectedClass
      this.setState({
        selectedClass: payload.class
      })
    }
    this.getIMDStudentList(payload)
  }

  setSelectedClass = (payload = {}) => {
    this.setState({
      selectedClass: payload.class
    }, _ => {
      delete this.filter.class
      delete this.filter.page
      if(payload.class) this.filter.class = payload.class
      this.getIMDStudentList(this.filter)
    })
  }

  getIMDStudentList = (payload = {}) => {
    const {selectedClass} = this.state
    const {reportScreen} = this.props
    this.setState({
      isLoading: true
    })
    if(reportScreen === "improvement") payload.finishlineStatus = "COMPLETED"
    if(selectedClass) payload.class = selectedClass
    if (!payload.page) payload.page = 1
    if (!payload.limit) payload.limit = this.limit
    this.currentPage = payload.page
    payload.eventId = this.gmcAllowed ? Constants.GMC_EVENT_ID: Constants.IMD_EVENT_ID
    if (this.currentPage === 1) this.startIndex = 1

      SchoolUserApi.getIMDStudentList(payload)
        .then(result => {
          this.setState({
            imdStudents: result.response,
            meta: result.meta,
            isLoading: false
          })
        })
        .catch(err => {
          console.log(err)
        })
  }

  onFilterGo = (payload ={}) => {
    this.filter = payload    
    this.getIMDStudentList(this.filter)
  }

  onPageSelected = (selectedPage, startIndex) => {
    this.startIndex = startIndex
    this.filter.page = selectedPage
    this.setState({selectedPage})
    this.getIMDStudentList(this.filter)
  }

  renderPercentageChange(baseline, finish) {
    let initialValue = baseline && baseline.markScored ? (baseline.markScored/baseline.totalMark) * 100 : 0
    let finalValue = finish && finish.markScored ? (finish.markScored/finish.totalMark) * 100 : 0
    let calcValue = Math.round(finalValue) - Math.round(initialValue);
    // if(finalValue !== 0) {
    //     if(initialValue !== 0) {
    //         percent = (finalValue - initialValue) / initialValue * 100;
    //     } else {
    //         percent = finalValue * 100;
    //     }
    // } else {
    //     percent = - initialValue * 100;
    // }       
    return (
      <div className={`${calcValue >= 0 ? 'percentage-up': 'percentage-down'}`}>
        {
          calcValue >= 0 ? (
            <FontAwesomeIcon icon={faArrowUp} />
          ) : (
            <FontAwesomeIcon icon={faArrowDown} />
          )
        }
        {"  " + Math.abs(Math.round(calcValue))}%
        
      </div>
    )
}

  render () {
    const { imdStudents } = this.state
    const { reportScreen } = this.props
    console.log(reportScreen);
    return (
      <>
        {reportScreen === "students" && 
          <FilterComponent onGo={this.onFilterGo} delegate={this} />
        }
        <div id='table-scoll' className='table-responsive mt-5'>
          {this.state.isLoading && <Loading style={{top: '100px'}}></Loading>}
          <table className='table cw-table mb-0 align-items-center student-list'>
            <thead>
              <tr>
                <th className='text-center th-left-radius'>Sr no</th>
                <th className='text-center'>Student</th>
                <th className='text-center'>Class</th>
                <th className='text-center'>Baseline Assessment</th>
                
                {reportScreen === "students" && 
                  <th className='text-center'>Qualifying Course</th>
                }
                <th className='text-center'>Finishline Assessment</th>
                {reportScreen === 'improvement' && <th className='text-center th-right-radius'>Improvement</th>}
              </tr>
            </thead>
            <tbody className='bg-white'>
              {imdStudents.length > 0 &&
                imdStudents.map((student, index) => (
                  <tr key={index} className='mt-4'>
                    <td className="text-center">{(index + 1) + ((this.currentPage - 1) * 10)}.</td>
                    <td className="text-center"><div className='name-text'>{student?.name}</div>{student?.isSubscribed && <div><span className='premium-text'>{"Premium"}</span></div>}</td>
                    <td className="text-center">{student?.class}</td>
                    {reportScreen === "students" && 
                      <td className="text-center">
                        <span className='check-circle'>
                          {student?.eventBaseline && student?.eventBaseline?.status === 'COMPLETED' ? (
                            <FontAwesomeIcon icon={faCheckCircle} color='#6ae5d3' />
                          ) : (
                            <FontAwesomeIcon icon={faTimesCircle} color='#ed4040' />
                          )}
                        </span>

                      </td>
                    }
                    {reportScreen === "students" && 
                      <td className="text-center">
                        <span className='check-circle'>
                          {
                            (student?.qualified || student?.eventWorkflow?.percentage >= 100) ? (
                              <FontAwesomeIcon icon={faCheckCircle} color='#6ae5d3' />
                            ) : (
                              <FontAwesomeIcon icon={faTimesCircle} color='#ed4040' />
                            )
                          }
                        </span>
                      </td>
                    }
                    {reportScreen === "students" && 
                      <td className="text-center">
                        <span className='check-circle'>
                          {student?.finalAssessment &&
                          student?.finalAssessment?.status === 'COMPLETED' ? (
                            <FontAwesomeIcon icon={faCheckCircle} color='#6ae5d3' />
                          ) : (
                            <FontAwesomeIcon icon={faTimesCircle} color='#ed4040' />
                          )}
                        </span>

                      </td>
                    }
                    {reportScreen === "improvement" && 
                      <td className="text-center">
                        {student?.eventBaseline?.markScored
                        ? Math.round((student.eventBaseline.markScored /
                            student.eventBaseline.totalMark) *
                          100) + "%"
                        : "--"}
                      </td>
                    }
                    {reportScreen === "improvement" && 
                      <td className="text-center">
                        {student?.finalAssessment?.markScored
                          ? Math.round((student.finalAssessment.markScored /
                            student.finalAssessment.totalMark) *
                          100) + "%"
                        : "--"}
                      </td>
                    }
                    {reportScreen === 'improvement' && 
                      <td className="text-center">
                        {this.renderPercentageChange(student?.eventBaseline, student?.finalAssessment)}
                      </td>
                    }
                  </tr>
                ))}
              {!imdStudents.length && (
                <tr className='mt-4'>
                  <td colSpan='8' className='text-center'>
                    {' '}
                    No Records Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <div className='card-footer'>
              {
                 !this.state.isLoading && this.state.meta.totalPages ?
                      <PaginationComponent startIndex={this.startIndex} selectedPage={this.currentPage} totalPages={this.state.meta.totalPages} onPageSelected={this.onPageSelected.bind(this)} /> : ''
              }
          </div>
        </div>
      </>
    )
  }
}

export default IMDStudents
